// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".ErrorIcon__error-icon--25vnK {\r\n    fill: #C2185B;\r\n    height: 24px;\r\n    width: auto;\r\n}", "",{"version":3,"sources":["ErrorIcon.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;AACf","file":"ErrorIcon.css","sourcesContent":[".error-icon {\r\n    fill: #C2185B;\r\n    height: 24px;\r\n    width: auto;\r\n}"]}]);
// Exports
exports.locals = {
	"error-icon": "ErrorIcon__error-icon--25vnK",
	"errorIcon": "ErrorIcon__error-icon--25vnK"
};
module.exports = exports;
